import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import HeaderMenu from '../menu/header_container';
import config from '../../config';
import DataTable from '../widgets/DataTable';
import { toast } from '../widgets/alerts/Toast';
import './portalClientesAcceso.css';

const EMPRESA_GTIC = '111111111';

const api = (path, options = {}) =>
  fetch(`${config.servBackEnd}/portalclientes${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      empresa: sessionStorage.getItem('company'),
      tipo: sessionStorage.getItem('tipo'),
      currentUser: sessionStorage.getItem('_id') || ''
    }
  }).then(async (res) => ({ status: res.status, ...(await res.json()) }));

const aviso = (type, title, description) =>
  toast({ title, description, type, position: 'bottom-center', duration: type === 'error' ? 6 : 4 });

// Acepta NIT copiados de Excel: quita puntos y, si el valor tal cual no existe como cliente, el dígito de
// verificación (901.583.264-7 -> 901583264). Así un cliente cuyo documento lleva guion (p. ej. una sucursal "123-1")
// no se confunde con el cliente "123".
const resolverDocumento = (token, existentes) => {
  const sinPuntos = token.replace(/\./g, '').trim();
  return existentes.has(sinPuntos) ? sinPuntos : sinPuntos.split('-')[0].trim();
};
const parsearLista = (texto, existentes) => [...new Set(texto.split(/[\s,;]+/).filter(Boolean).map((t) => resolverDocumento(t, existentes)).filter(Boolean))];

const BotonCarga = ({ cargando, textoCarga, disabled, className = 'pc-btn pc-btn-ghost', children, ...rest }) => (
  <button type="button" className={`${className}${cargando ? ' pc-loading' : ''}`} disabled={cargando || disabled} {...rest}>
    {cargando && <span className="pc-spin" aria-hidden="true" />}
    {cargando && textoCarga ? textoCarga : children}
  </button>
);

// Modal con el mismo diseño de los modales del nuevo POS (pl-modal-*)
const ModalPc = ({ titulo, onClose, cerrarBloqueado, ancho, children, pie }) => (
  <div className="pc-modal-overlay" role="dialog" aria-modal="true" aria-label={titulo}>
    <div className="pc-modal-card" style={ancho ? { maxWidth: ancho } : undefined}>
      <div className="pc-modal-header">
        <h3>{titulo}</h3>
        <button type="button" className="pc-modal-close" aria-label="Cerrar" disabled={cerrarBloqueado} onClick={onClose}><FaTimes /></button>
      </div>
      <div className="pc-modal-body">{children}</div>
      <div className="pc-modal-footer">{pie}</div>
    </div>
  </div>
);

const CAMPOS_EMPRESA = { ingreso_clientes: 'INGRESO_CLIENTES', modo_ingreso_clientes: 'MODO_INGRESO_CLIENTES', cupo_ingreso_clientes: 'CUPO_INGRESO_CLIENTES' };

const Switch = ({ activo, disabled, onClick, titulo }) => (
  <button type="button" role="switch" aria-checked={activo} aria-label={titulo} title={titulo} disabled={disabled} onClick={onClick} className={`pc-switch${activo ? ' on' : ''}`}>
    <span />
  </button>
);

const EstadoBadge = ({ habilitado }) => (
  <span className={`pc-badge ${habilitado ? 'pc-badge-on' : 'pc-badge-off'}`}>{habilitado ? 'Habilitado' : 'No habilitado'}</span>
);

const CupoBarra = ({ habilitados, cupo }) => {
  const pct = cupo ? Math.min(100, Math.round((habilitados / cupo) * 100)) : 0;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '140px' }}>
      {cupo !== null && cupo !== undefined && (
        <div className="pc-bar" style={{ flex: 1 }}>
          <i style={{ width: `${pct}%` }} />
        </div>
      )}
      <strong style={{ color: '#1b2f55', whiteSpace: 'nowrap', fontSize: '12px' }}>
        {habilitados}{cupo !== null && cupo !== undefined ? ` / ${cupo}` : ''}
      </strong>
    </div>
  );
};

const CupoCell = ({ valor, modo, cargando, onGuardar }) => {
  const original = valor === null || valor === undefined ? '' : String(valor);
  const [txt, setTxt] = useState(original);
  useEffect(() => setTxt(original), [original]);
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <input
        type="number"
        min="0"
        aria-label="Cupo de clientes"
        title={modo === 1 ? 'Máximo de clientes habilitados' : 'Se aplica al activar «Solo habilitados»'}
        placeholder="Sin límite"
        value={txt}
        disabled={cargando}
        onChange={(e) => setTxt(e.target.value)}
        className={`pc-input${modo === 1 ? '' : ' pc-dim'}`}
        style={{ width: '96px' }}
      />
      {txt !== original && (
        <BotonCarga className="pc-btn pc-btn-primary" cargando={cargando} textoCarga="Guardando…" onClick={() => onGuardar(txt === '' ? null : Number(txt))}>
          Guardar
        </BotonCarga>
      )}
    </div>
  );
};

function PortalClientesAcceso() {
  const company = sessionStorage.getItem('company');

  const [empresas, setEmpresas] = useState([]);
  const [loadingEmp, setLoadingEmp] = useState(true);
  const [confirmar, setConfirmar] = useState({ show: false });
  const [accionEmpresa, setAccionEmpresa] = useState(null);
  const avisoColumnas = useRef(false);

  const [empresaSel, setEmpresaSel] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [loadingCli, setLoadingCli] = useState(false);
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [seleccion, setSeleccion] = useState(new Set());
  const [visibleRows, setVisibleRows] = useState([]);
  const [accion, setAccion] = useState(null);
  const [procesando, setProcesando] = useState(new Set());

  const [pegarShow, setPegarShow] = useState(false);
  const [textoPegado, setTextoPegado] = useState('');

  const cargarEmpresas = useCallback(() => {
    setLoadingEmp(true);
    api('/empresas')
      .then((res) => {
        if (res.ok) setEmpresas(res.data);
        else if (res.columnasPendientes) {
          if (!avisoColumnas.current) {
            avisoColumnas.current = true;
            toast({ title: 'Configuración pendiente', description: 'Faltan columnas de control en la base de datos. Ejecute el script de BD de ingreso de clientes.', type: 'neutral-blue', position: 'bottom-center', duration: 0 });
          }
        } else aviso('error', 'No se pudo cargar las empresas', res.message);
        setLoadingEmp(false);
      })
      .catch(() => {
        aviso('error', 'Sin conexión', 'No se pudo conectar con el servidor');
        setLoadingEmp(false);
      });
  }, []);

  const cargarClientes = useCallback((idEmpresa) => {
    setLoadingCli(true);
    api(`/empresas/${idEmpresa}/clientes`)
      .then((res) => {
        if (res.ok) setClientes(res.data);
        else aviso('error', 'No se pudo cargar los clientes', res.message);
        setLoadingCli(false);
      })
      .catch(() => {
        aviso('error', 'Sin conexión', 'No se pudo conectar con el servidor');
        setLoadingCli(false);
      });
  }, []);

  useEffect(() => {
    if (company === EMPRESA_GTIC) cargarEmpresas();
  }, [company, cargarEmpresas]);

  const pedirConfirmacion = (cfg) => setConfirmar({ show: true, type: 'warning', ...cfg });

  const guardarEmpresa = (row, cambios) => {
    setAccionEmpresa(row.ID_EMPRESA);
    return api(`/empresas/${row.ID_EMPRESA}`, { method: 'POST', body: JSON.stringify(cambios) })
      .then((res) => {
        if (res.ok) {
          aviso('successful', 'Configuración actualizada', row.RAZON_SOCIAL);
          // Actualiza solo la fila afectada (sin recargar toda la tabla)
          const nuevos = Object.fromEntries(Object.entries(cambios).map(([k, v]) => [CAMPOS_EMPRESA[k], v]));
          setEmpresas((prev) => prev.map((e) => (e.ID_EMPRESA === row.ID_EMPRESA ? { ...e, ...nuevos } : e)));
        } else {
          aviso(res.status === 409 ? 'warning' : 'error', 'No se pudo guardar', res.message);
        }
      })
      .catch(() => aviso('error', 'Sin conexión', 'No se pudo conectar con el servidor'))
      .then(() => setAccionEmpresa(null));
  };

  const cambiarIngreso = (row) => {
    const nuevo = Number(row.INGRESO_CLIENTES) === 1 ? 0 : 1;
    pedirConfirmacion({
      title: nuevo ? 'Activar ingreso de clientes' : 'Desactivar ingreso de clientes',
      message: nuevo
        ? `¿Activar el ingreso de clientes para ${row.RAZON_SOCIAL}?`
        : `¿Desactivar el ingreso de clientes para ${row.RAZON_SOCIAL}? Ninguno de sus clientes podrá iniciar sesión en el portal.`,
      onConfirm: () => guardarEmpresa(row, { ingreso_clientes: nuevo })
    });
  };

  const cambiarModo = (row, modo) => {
    const sinLista = modo === 1 && Number(row.HABILITADOS) === 0
      ? ' Hoy no hay ningún cliente habilitado, así que nadie podrá ingresar hasta habilitar clientes.'
      : '';
    pedirConfirmacion({
      title: 'Cambiar modo de ingreso',
      message: modo === 1
        ? `¿Permitir el ingreso solo a los clientes habilitados de ${row.RAZON_SOCIAL}?${sinLista}`
        : `¿Permitir el ingreso a todos los clientes de ${row.RAZON_SOCIAL}?`,
      onConfirm: () => guardarEmpresa(row, { modo_ingreso_clientes: modo })
    });
  };

  const abrirEmpresa = (row) => {
    setEmpresaSel(row);
    setFiltroEstado('todos');
    setSeleccion(new Set());
    setClientes([]);
    cargarClientes(row.ID_EMPRESA);
  };

  const volverAEmpresas = () => {
    // Refleja en la fila el conteo ya conocido, sin volver a consultar el listado
    if (empresaSel && !loadingCli) {
      const total = clientes.filter((c) => Number(c.HABILITADO) === 1).length;
      setEmpresas((prev) => prev.map((e) => (e.ID_EMPRESA === empresaSel.ID_EMPRESA ? { ...e, HABILITADOS: total } : e)));
    }
    setEmpresaSel(null);
  };

  const habilitadosActuales = useMemo(() => clientes.filter((c) => Number(c.HABILITADO) === 1).length, [clientes]);
  const modo = empresaSel ? Number(empresaSel.MODO_INGRESO_CLIENTES) : 0;
  const cupo = empresaSel && empresaSel.CUPO_INGRESO_CLIENTES !== null && empresaSel.CUPO_INGRESO_CLIENTES !== undefined
    ? Number(empresaSel.CUPO_INGRESO_CLIENTES)
    : null;

  // origen: 'lote' | 'fila' | 'pegado' (define qué botón muestra el spinner)
  const aplicarLote = (documentos, habilitar, origen) => {
    const porHabilitar = habilitar
      ? clientes.filter((c) => documentos.includes(String(c.DOCUMENTO_CLIENTE)) && Number(c.HABILITADO) !== 1).length
      : 0;
    if (habilitar && cupo !== null && habilitadosActuales + porHabilitar > cupo) {
      aviso('warning', 'Excede el cupo', `Hay ${habilitadosActuales} de ${cupo} habilitados y se intentan habilitar ${porHabilitar} más.`);
      return Promise.resolve(false);
    }
    setAccion(`${origen}-${habilitar ? 'hab' : 'des'}`);
    if (origen === 'fila') setProcesando(new Set(documentos));
    return api(`/empresas/${empresaSel.ID_EMPRESA}/clientes`, {
      method: 'POST',
      body: JSON.stringify({ documentos, habilitado: habilitar })
    })
      .then((res) => {
        if (!res.ok) {
          aviso(res.status === 409 ? 'warning' : 'error', 'No se pudo aplicar el cambio', res.message);
          return false;
        }
        const noEnc = res.no_encontrados && res.no_encontrados.length > 0
          ? ` ${res.no_encontrados.length} documento(s) no existen como cliente de la empresa.`
          : '';
        aviso('successful', habilitar ? 'Clientes habilitados' : 'Clientes deshabilitados', `${res.aplicados} cliente(s) actualizados.${noEnc}`);
        setSeleccion(new Set());
        // Actualiza solo las filas afectadas (el DataTable conserva página, orden y búsqueda)
        const afectados = new Set(documentos);
        setClientes((prev) => prev.map((c) => (afectados.has(String(c.DOCUMENTO_CLIENTE)) ? { ...c, HABILITADO: habilitar ? 1 : 0 } : c)));
        return true;
      })
      .catch(() => {
        aviso('error', 'Sin conexión', 'No se pudo conectar con el servidor');
        return false;
      })
      .then((ok) => {
        setAccion(null);
        setProcesando(new Set());
        return ok;
      });
  };

  const seleccionarLote = (habilitar) => {
    const docs = [...seleccion];
    if (habilitar) {
      aplicarLote(docs, true, 'lote');
    } else {
      pedirConfirmacion({
        title: 'Deshabilitar clientes',
        message: `¿Deshabilitar ${docs.length} cliente(s)? No podrán ingresar al portal mientras la empresa esté en modo "Solo habilitados".`,
        onConfirm: () => aplicarLote(docs, false, 'lote')
      });
    }
  };

  const handleFilteredDataChange = useCallback((rows) => {
    setVisibleRows((prev) => {
      if (prev.length !== rows.length) return rows;
      for (let i = 0; i < rows.length; i++) {
        if (prev[i] !== rows[i]) return rows;
      }
      return prev;
    });
  }, []);

  const clientesFiltrados = useMemo(() => {
    if (filtroEstado === 'habilitados') return clientes.filter((c) => Number(c.HABILITADO) === 1);
    if (filtroEstado === 'no') return clientes.filter((c) => Number(c.HABILITADO) !== 1);
    return clientes;
  }, [clientes, filtroEstado]);

  const todosVisiblesSeleccionados = visibleRows.length > 0 && visibleRows.every((r) => seleccion.has(String(r.DOCUMENTO_CLIENTE)));

  const alternarTodos = () => {
    setSeleccion((prev) => {
      const next = new Set(prev);
      visibleRows.forEach((r) => (todosVisiblesSeleccionados ? next.delete(String(r.DOCUMENTO_CLIENTE)) : next.add(String(r.DOCUMENTO_CLIENTE))));
      return next;
    });
  };

  const alternarUno = (doc) => {
    setSeleccion((prev) => {
      const next = new Set(prev);
      if (next.has(doc)) next.delete(doc);
      else next.add(doc);
      return next;
    });
  };

  const columnasEmpresas = useMemo(() => [
    { key: 'ID_EMPRESA', label: 'NIT', sortable: true, render: (val) => <span className="pc-nit">{val}</span> },
    { key: 'RAZON_SOCIAL', label: 'Razón Social', sortable: true },
    {
      key: 'INGRESO_CLIENTES',
      label: 'Ingreso de Clientes',
      sortable: true,
      render: (val, row) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Switch
            activo={Number(val) === 1}
            disabled={!row.TIENE_PARAMETROS || accionEmpresa === row.ID_EMPRESA}
            titulo={row.TIENE_PARAMETROS ? 'Activar o desactivar el ingreso de clientes' : 'La empresa no tiene fila en EMPRESA_PARAMETROS'}
            onClick={() => cambiarIngreso(row)}
          />
          <span style={{ fontSize: '12px', color: Number(val) === 1 ? '#1b2f55' : '#5b6f94', fontWeight: '600' }}>
            {accionEmpresa === row.ID_EMPRESA ? <span className="pc-spin" aria-label="Guardando" /> : null}
            {Number(val) === 1 ? 'Activo' : 'Inactivo'}
          </span>
        </div>
      )
    },
    {
      key: 'MODO_INGRESO_CLIENTES',
      label: 'Modo',
      render: (val, row) => (
        <select
          aria-label="Modo de ingreso de clientes"
          value={Number(val)}
          disabled={!row.TIENE_PARAMETROS || accionEmpresa === row.ID_EMPRESA}
          onChange={(e) => cambiarModo(row, Number(e.target.value))}
          className="pc-input"
        >
          <option value={0}>Todos los clientes</option>
          <option value={1}>Solo habilitados</option>
        </select>
      )
    },
    {
      key: 'CUPO_INGRESO_CLIENTES',
      label: 'Cupo',
      render: (val, row) => (
        <CupoCell
          key={row.ID_EMPRESA}
          valor={val}
          modo={Number(row.MODO_INGRESO_CLIENTES)}
          cargando={accionEmpresa === row.ID_EMPRESA}
          onGuardar={(nuevo) => guardarEmpresa(row, { cupo_ingreso_clientes: nuevo })}
        />
      )
    },
    {
      key: 'HABILITADOS',
      label: 'Habilitados',
      sortable: true,
      render: (val, row) => {
        if (Number(row.MODO_INGRESO_CLIENTES) !== 1) {
          return (
            <div>
              <span className="pc-chip">Todos</span>
              {Number(val) > 0 && <span className="pc-mute" style={{ display: 'block' }}>{Number(val)} preparados</span>}
            </div>
          );
        }
        return <CupoBarra habilitados={Number(val) || 0} cupo={row.CUPO_INGRESO_CLIENTES === null ? null : Number(row.CUPO_INGRESO_CLIENTES)} />;
      }
    },
    {
      key: 'acciones',
      label: '',
      render: (_, row) => (
        <button type="button" className="pc-btn pc-btn-ghost" onClick={() => abrirEmpresa(row)}>
          Gestionar clientes
        </button>
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ], [accionEmpresa]);

  const columnasClientes = useMemo(() => [
    {
      key: 'seleccion',
      label: <Form.Check type="checkbox" id="sel-todos" aria-label="Seleccionar todos" checked={todosVisiblesSeleccionados} onChange={alternarTodos} />,
      sortable: false,
      style: { width: '30px', padding: '0 8px', textAlign: 'center' },
      render: (_, row) => (
        <Form.Check
          type="checkbox"
          id={`sel-${row.DOCUMENTO_CLIENTE}`}
          checked={seleccion.has(String(row.DOCUMENTO_CLIENTE))}
          onChange={() => alternarUno(String(row.DOCUMENTO_CLIENTE))}
        />
      )
    },
    { key: 'DOCUMENTO_CLIENTE', label: 'NIT / Documento', sortable: true, render: (val) => <span className="pc-nit">{val}</span> },
    { key: 'NOMBRE_CLIENTE', label: 'Cliente', sortable: true },
    {
      key: 'HABILITADO',
      label: 'Estado',
      sortable: true,
      render: (val) => <EstadoBadge habilitado={Number(val) === 1} />
    },
    {
      key: 'acciones',
      label: '',
      render: (_, row) => {
        const habilitado = Number(row.HABILITADO) === 1;
        const doc = String(row.DOCUMENTO_CLIENTE);
        return (
          <BotonCarga
            cargando={procesando.has(doc)}
            textoCarga={habilitado ? 'Deshabilitando…' : 'Habilitando…'}
            disabled={accion !== null}
            onClick={() => aplicarLote([doc], !habilitado, 'fila')}
          >
            {habilitado ? 'Deshabilitar' : 'Habilitar'}
          </BotonCarga>
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ], [seleccion, visibleRows, accion, procesando, clientes, empresaSel]);

  // Vista previa del pegado de NIT: contra los clientes ya cargados de la empresa.
  const previa = useMemo(() => {
    const mapa = new Map(clientes.map((c) => [String(c.DOCUMENTO_CLIENTE), c]));
    const leidos = parsearLista(textoPegado, mapa);
    const encontrados = leidos.filter((d) => mapa.has(d));
    const noEncontrados = leidos.filter((d) => !mapa.has(d));
    const nuevos = encontrados.filter((d) => Number(mapa.get(d).HABILITADO) !== 1);
    const restante = cupo === null ? null : cupo - habilitadosActuales - nuevos.length;
    return { leidos, encontrados, noEncontrados, nuevos, restante };
  }, [textoPegado, clientes, cupo, habilitadosActuales]);

  const aplicarPegado = () => {
    aplicarLote(previa.encontrados, true, 'pegado').then((ok) => {
      if (ok) {
        setPegarShow(false);
        setTextoPegado('');
      }
    });
  };

  if (company !== EMPRESA_GTIC) return <Redirect to="/" />;

  const noHabilitados = clientes.length - habilitadosActuales;
  const SEGMENTOS = [
    { key: 'todos', label: `Todos (${clientes.length})` },
    { key: 'habilitados', label: `Habilitados (${habilitadosActuales})` },
    { key: 'no', label: `No habilitados (${noHabilitados})` }
  ];

  return (
    <React.Fragment>
      <HeaderMenu />
      <div className="pc-root">
        <div className="pc-banner">
          <h2>{empresaSel ? `Clientes de ${empresaSel.RAZON_SOCIAL}` : 'Ingreso de Clientes'}</h2>
          <p>
            {empresaSel
              ? 'Habilite o deshabilite los clientes que pueden ingresar al portal de esta empresa'
              : 'Control del ingreso de clientes al portal por empresa: activación, modo de ingreso y cupo'}
          </p>
        </div>

        <div className="pc-content">
        {!empresaSel && (
          <div className="pc-body">
            <DataTable
              data={empresas}
              columns={columnasEmpresas}
              loading={loadingEmp}
              searchKeys={['ID_EMPRESA', 'RAZON_SOCIAL']}
              searchPlaceholder="Buscar empresa por NIT o razón social..."
              emptyText="No se encontraron empresas"
              defaultItemsPerPage={20}
            />
          </div>
        )}

        {empresaSel && (
          <React.Fragment>
            <div className="pc-panel">
              <div className="pc-top">
                <button type="button" className="pc-btn pc-btn-ghost" onClick={volverAEmpresas}>
                  ← Volver a empresas
                </button>
                <div className="pc-title">
                  <span className={`pc-chip${Number(empresaSel.INGRESO_CLIENTES) === 1 ? ' pc-chip-strong' : ''}`}>
                    {Number(empresaSel.INGRESO_CLIENTES) === 1 ? 'Ingreso activo' : 'Ingreso desactivado'}
                  </span>
                  <span className="pc-chip">{modo === 1 ? 'Solo habilitados' : 'Todos los clientes'}</span>
                </div>
                <div className="pc-meter">
                  {modo === 1 ? (
                    <React.Fragment>
                      <div className="pc-meter-top">
                        <b>{habilitadosActuales}{cupo !== null ? ` / ${cupo}` : ''}</b> habilitados
                      </div>
                      {cupo !== null && (
                        <div className="pc-bar"><i style={{ width: `${Math.min(100, Math.round((habilitadosActuales / (cupo || 1)) * 100))}%` }} /></div>
                      )}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span className="pc-meter-text">Pueden ingresar todos los clientes</span>
                      <small>Lista preparada: {habilitadosActuales} {habilitadosActuales === 1 ? 'cliente' : 'clientes'} · rige al activar «Solo habilitados»</small>
                    </React.Fragment>
                  )}
                </div>
              </div>

              <div className="pc-tools">
                <div className="pc-seg" role="group" aria-label="Filtrar por estado">
                  {SEGMENTOS.map((s) => (
                    <button key={s.key} type="button" className={filtroEstado === s.key ? 'on' : ''} onClick={() => setFiltroEstado(s.key)}>
                      {s.label}
                    </button>
                  ))}
                </div>
                <BotonCarga onClick={() => setPegarShow(true)}>Habilitar por lista de NIT</BotonCarga>
              </div>

              {seleccion.size > 0 && (
                <div className="pc-selbar" role="region" aria-label="Acciones sobre la selección">
                  <span>{seleccion.size} seleccionado(s)</span>
                  <span className="pc-grow" />
                  <BotonCarga
                    className="pc-btn pc-btn-primary"
                    cargando={accion === 'lote-hab'}
                    textoCarga="Habilitando…"
                    disabled={accion !== null}
                    onClick={() => seleccionarLote(true)}
                  >
                    Habilitar
                  </BotonCarga>
                  <BotonCarga
                    cargando={accion === 'lote-des'}
                    textoCarga="Deshabilitando…"
                    disabled={accion !== null}
                    onClick={() => seleccionarLote(false)}
                  >
                    Deshabilitar
                  </BotonCarga>
                  <button type="button" className="pc-link" onClick={() => setSeleccion(new Set())}>Limpiar</button>
                </div>
              )}
            </div>

            <div className="pc-body">
              <DataTable
                data={clientesFiltrados}
                columns={columnasClientes}
                loading={loadingCli}
                searchKeys={['DOCUMENTO_CLIENTE', 'NOMBRE_CLIENTE']}
                searchPlaceholder="Buscar cliente por NIT o nombre..."
                emptyText="No se encontraron clientes con los filtros aplicados"
                defaultItemsPerPage={20}
                onFilteredDataChange={handleFilteredDataChange}
              />
            </div>
          </React.Fragment>
        )}
        </div>
      </div>

      {confirmar.show && (
        <ModalPc
          titulo={confirmar.title}
          onClose={() => setConfirmar({ show: false })}
          pie={(
            <React.Fragment>
              <button type="button" className="pc-btn pc-btn-secondary" onClick={() => setConfirmar({ show: false })}>Cancelar</button>
              <button
                type="button"
                className="pc-btn pc-btn-primary"
                onClick={() => {
                  const ok = confirmar.onConfirm;
                  setConfirmar({ show: false });
                  if (ok) ok();
                }}
              >
                Confirmar
              </button>
            </React.Fragment>
          )}
        >
          <p style={{ margin: 0 }}>{confirmar.message}</p>
        </ModalPc>
      )}

      {pegarShow && (
        <ModalPc
          titulo="Habilitar por lista de NIT"
          onClose={() => setPegarShow(false)}
          cerrarBloqueado={accion !== null}
          pie={(
            <React.Fragment>
              <button type="button" className="pc-btn pc-btn-secondary" disabled={accion !== null} onClick={() => setPegarShow(false)}>Cancelar</button>
              <BotonCarga
                className="pc-btn pc-btn-primary"
                cargando={accion === 'pegado-hab'}
                textoCarga="Aplicando…"
                disabled={previa.encontrados.length === 0}
                onClick={aplicarPegado}
              >
                Aplicar
              </BotonCarga>
            </React.Fragment>
          )}
        >
          <p>Ingrese la lista de NIT de los clientes a habilitar, sin dígito de verificación.</p>
          <textarea
            rows={8}
            aria-label="Lista de NIT"
            className="pc-form-input"
            placeholder={'860412759\n901583264\n...'}
            value={textoPegado}
            onChange={(e) => setTextoPegado(e.target.value)}
          />
          {previa.leidos.length > 0 && (
            <div className="pc-result">
              <span>Encontrados: <strong>{previa.encontrados.length}</strong></span>
              <span>No encontrados: <strong>{previa.noEncontrados.length}</strong></span>
            </div>
          )}
        </ModalPc>
      )}
    </React.Fragment>
  );
}

export default PortalClientesAcceso;



// WEBPACK FOOTER //
// ./src/components/configuracion/portalClientesAcceso.jsx